function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Vue from 'vue';
import { USER_INFO, ENHANCE_PRE, MENU, TENANT_CONFIG } from "@/store/mutation-types";
var getters = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
  device: function device(state) {
    return state.app.device;
  },
  theme: function theme(state) {
    return state.app.theme;
  },
  color: function color(state) {
    return state.app.color;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    state.user.avatar = Vue.ls.get(USER_INFO) && Vue.ls.get(USER_INFO).avatar;
    return state.user.avatar;
  },
  username: function username(state) {
    return state.user.username;
  },
  nickname: function nickname(state) {
    state.user.realname = Vue.ls.get(USER_INFO) && Vue.ls.get(USER_INFO).realname;
    return state.user.realname;
  },
  welcome: function welcome(state) {
    return state.user.welcome;
  },
  permissionList: function permissionList(state) {
    return state.user.permissionList;
  },
  menuList: function menuList(state) {
    state.user.menuList = Vue.ls.get(MENU);
    return state.user.menuList;
  },
  userInfo: function userInfo(state) {
    state.user.info = Vue.ls.get(USER_INFO);
    return state.user.info;
  }
}, "avatar", function avatar(state) {
  return state.user.avatar;
}), "tenantInfo", function tenantInfo(state) {
  state.user.tenantInfo = Vue.ls.get(TENANT_CONFIG);
  return state.user.tenantInfo;
}), "addRouters", function addRouters(state) {
  return state.permission.addRouters;
}), "onlAuthFields", function onlAuthFields(state) {
  return state.online.authFields;
}), "enhanceJs", function enhanceJs(state) {
  return function (code) {
    state.enhance.enhanceJs[code] = Vue.ls.get(ENHANCE_PRE + code);
    return state.enhance.enhanceJs[code];
  };
});
export default getters;